import { FncoPreMarketingSnapshot } from '@/components/Approval/@components/FncoPreMarketing';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 221 F&CO 마케팅 사전 — 저장 content 그대로(레거시 조회와 동일) */
const FncoPreMarketingSlot = ({ data }: ContentExtraProps) => {
  const content = (data.attributes as { content?: unknown } | null)?.content;
  if (typeof content !== 'string' || !content.trim()) return null;
  return (
    <ContentSlotRoot>
      <FncoPreMarketingSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default FncoPreMarketingSlot;
